// ==============================|| KEYS DE PERFIL ||============================== //
//
// El ÚNICO lugar del front que sabe qué key_profile tiene cada perfil.
//
// Las keys son aleatorias (decisión del usuario, 2026-10-07, db/113): un
// key_profile es un identificador, no un texto armado con el nombre del
// perfil. Es la misma regla que ya seguía el alta de perfiles desde la
// pantalla (ProfileController::store, generateToken(10)); los perfiles
// sembrados por script tenían keys legibles ('adm', 'auditor'...) y db/113 las
// cambió.
//
// Por eso el código NUNCA compara contra el texto de la key: usa estas
// constantes (PROFILE.ADMIN), que se leen claro y dejan en un solo punto la
// relación perfil -> key. Agregar un perfil con lógica propia es agregar aquí
// su constante con la key que se le dio en su script de db/.
//
// El API tiene el mismo mapa en api/app/Support/ProfileKeys.php; los dos
// deben coincidir.
//
// OJO: 'auditor' y 'dronero' siguen existiendo como ROL de asignación
// (AssignmentRole). Eso es el tipo de asignación, no la key del perfil, y no
// cambia.

export const PROFILE = {
  /** Administrador. */
  ADMIN: 'GWTUICRC7G',
  /** Administrador de ASF (db/106). */
  ADMIN_ASF: 'IOT76SVOFE',
  /** Dashboard: entra directo al panel GeoAudit. */
  DASHBOARD: '07EB20MNHI',
  /** Auditor. */
  AUDITOR: 'TPM9FQWI5S',
  /** Dronero. */
  PILOT: '0JEL26XOIY',
  /** Coordinador de procesamiento. */
  PROCESSING: 'AP8UZLS1PP',
  /** Legal Terrasat. */
  LEGAL: 'POW5Y9RTKF',
  /** Directora de área (ASF, db/112). Ve lo del Admin ASF acotado a su Estructura (db/120). */
  AREA_DIRECTOR: 'AMCJLE7FYQ',
  /** Subdirector de área (ASF, db/112). Igual que la Directora. */
  AREA_SUBDIRECTOR: '65PIVF3850',
  /** Jefe de Departamento (ASF, db/112). Arranca con copia de lo del Subdirector (db/179). */
  DEPT_HEAD: 'Z87PNESL9J',
  /** Coordinador de Auditores (ASF, db/179). Arranca con copia de lo del Subdirector. */
  AUDITOR_COORDINATOR: '1MGZH14FIT',
  /** Auditor Especializado en Municipios (titular AEM): permisos del Admin ASF acotados a Municipales (db/193). */
  AEM_AUDITOR: 'EIM2OAWK7T',
  /** Secretario Técnico AEM: igual que el titular (db/193). */
  AEM_SECRETARY: '16ILM9SVAL',
} as const;
